import ShowEachClient from "../components/ShowEachClient";
import NavBarComponent from "../components/NavBarComponent";

function EachClient() {
  return (  
    <>
    <NavBarComponent/>
    <ShowEachClient/>
    </>
  );
}

export default EachClient;